/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { createRoute } from '@gh/builder-shared';
import { AelListComponent } from './components/ael-list/ael-list.component';
import { AelListBusinessService } from './resources/ael-list-business.service';

const routes: Routes = [createRoute({
  component: AelListComponent,
  path: '',
  init: AelListBusinessService,
  auth: {
    permission: 'EventLog.VIEW',
  },
})];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderAelRoutingModule {
}
